import React, { useState } from 'react';
import { Router } from 'react-router-dom';
import PageNotFound from '../NotFoundState/PageNotFound';
import readRedesignTranslations from '../../services/readRedesignTranslations';
import useLocaleReloadHistory from '../../services/useLocaleReloadHistory';

function DirectLinkNotFound() {
    const [translations] = useState(readRedesignTranslations);
    const history = useLocaleReloadHistory();

    return (
        <Router history={history}>
            <PageNotFound
                title={translations.notFoundPageTitle}
                description={translations.notFoundPageDisclaimer}
                backHomeLabel={translations.notFoundPageBackHome}
                testId="redesign-error-not-found"
                backHomeTestId="redesign-error-not-found-back-home"
            />
        </Router>
    );
}

export default DirectLinkNotFound;
